import { Form as BootstrapForm } from "react-bootstrap";
import styled from "styled-components";

export const StyledCheck = styled(BootstrapForm.Check).attrs({
  type: "checkbox",
})``;
